import { useEffect } from 'react';

import { useSetAtom } from 'jotai';

import { IovationBlackboxAtomT, IovationWindowT } from '@consumer-frontend/nc-utils';

const IOVATION_SCRIPT_ID = 'iovation-loader';

export const useIovation = (iovationBlackboxAtom: IovationBlackboxAtomT): void => {
  const setBlackbox = useSetAtom(iovationBlackboxAtom);

  // Initialize Iovation in the window and collect the blackbox string.
  // Set the blackbox atom when the blackbox callback is invoked.
  useEffect(
    () => {
      const iovationWindow: IovationWindowT = window;

      const blackboxCallback = (blackBoxString: string, isComplete: boolean) => {
        setBlackbox({ blackbox: blackBoxString, isComplete });
      };

      iovationWindow.IGLOO = iovationWindow.IGLOO || {
        bb_callback: blackboxCallback,
        enable_flash: false,
        enable_rip: true,
        install_flash: false,
        loader: {
          version: 'general5',
        },
      };

      if (!document.getElementById(IOVATION_SCRIPT_ID)) {
        const script = document.createElement('script');

        script.id = IOVATION_SCRIPT_ID;
        script.src = import.meta.env.VITE_IOVATION_LOADER_URL;

        script.async = true;
        document.head.appendChild(script);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
};
